module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAZCAMAAADt/kXiAAAAPFBMVEVMaXFYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFpYWFq4sYd6AAAAE3RSTlMA0KBgEDDwQIDAsCBwUB/ofkzcFITJeAAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAHBJREFUKJG90MkOwzAIRdFnB4yHpEnL//9rVbuZineJepcHJCRwaHmgl9eZLVMK+gpmQC6wPrMOlqECfx5U/jhG9Tuzc4TmGNTTl0uo3ByyHefcNprbLjlNHSdGTB2P6Z8e18f8+N6NPmqvDBKbSHkDRgcGx0FyQE4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/upload.png
// module id = 25
// module chunks = 0